/* eslint-disable react/react-in-jsx-scope */
import { getProviders, removeProvider, addProvider, updateProvider } from "../services/providers";
import DataTable from "../components/Table/DataTable";
import { getProvidersExpertise } from "../services/providersExpertise";
import { roles } from "../utils/roles";
import { getAgencies } from "../services/agencies";

const headCells = [
  {
    field: "name",
    headerName: "Name",
    sortable: true,
    editable: false,
    isOnTable: true,
    type: "textField",
    flex: 1,
    filterable: false,
    isOnFilter: true,
    isRequired: true,
    helperText: "Please provide a name.",
  },
  {
    field: "expertiseList",
    headerName: "Providers' expertise",
    sortable: true,
    editable: false,
    isOnTable: true,
    type: "selectAutocomplete",
    isSelectMultiple: true,
    flex: 1,
    filterable: true,
    isOnFilter: true,
    valueGetter: (value) => value.map((expertise) => expertise.name).join(", "),
    fetchAction: getProvidersExpertise,
  },
  {
    field: "email",
    headerName: "Email",
    sortable: true,
    editable: false,
    isOnTable: true,
    type: "textField",
    flex: 1,
    filterable: false,
  },
  {
    field: "phoneNumber",
    headerName: "Phone number",
    sortable: true,
    editable: false,
    isOnTable: true,
    type: "textField",
    flex: 1,
    filterable: false,
  },
  {
    field: "note",
    headerName: "Note",
    sortable: true,
    editable: false,
    isOnTable: true,
    type: "textField",
    flex: 1,
    filterable: false,
  },
  {
    field: "price",
    headerName: "Price",
    sortable: true,
    editable: false,
    isOnTable: true,
    type: "textField",
    flex: 1,
    filterable: false,
  },
  {
    field: "agencies",
    headerName: "Agency",
    sortable: true,
    editable: false,
    isOnTable: false,
    isOnEditPopin: false,
    isSuperAdminEditOnly: true,
    type: "selectAutocomplete",
    isSelectMultiple: false,
    flex: 1,
    filterable: true,
    isOnFilter: false,
    valueGetter: (value) => value.map((agency) => agency.name).join(", "),
    fetchAction: getAgencies,
  },
];

const entity = {
  tableId: "providers",
  label: "provider",
};

const permissions = {
  read: [roles.ALL],
  delete: [roles.PM, roles.SALE, roles.ADMIN, roles.SUPERADMIN],
  create: [roles.PM, roles.SALE, roles.ADMIN, roles.SUPERADMIN],
  update: [roles.PM, roles.SALE, roles.ADMIN, roles.SUPERADMIN],
};

export default function ProvidersPages() {
  return <DataTable permissions={permissions} entity={entity} fetchData={getProviders} addData={addProvider} deleteData={removeProvider} updateData={updateProvider} headCells={headCells} />;
}
